{
  "generatedAt": "2026-10-18T00:00:00.000Z",
  "source": "Elite Dangerous Wiki (Fandom), \"Engineers\" page and individual engineer pages",
  "sourceUrl": "https://elite-dangerous.fandom.com/wiki/Engineers",
  "retrievedAt": "2026-10-18",
  "note": "Community-curated locations and access requirements, not official Frontier data. Verify critical details in-game before travelling.",
  "engineers": [
    {
      "key": "tod-the-blaster-mcquinn",
      "kind": "ship",
      "system": "Wolf 397",
      "base": "Trophy Camp",
      "planet": "Trus Madi",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Earn 15 bounty vouchers",
      "unlock": "Provide 100,000 CR worth of bounty vouchers",
      "reputation": "Craft modules, hand in Alliance vouchers to Trophy Camp"
    },
    {
      "key": "felicity-farseer",
      "kind": "ship",
      "system": "Deciat",
      "base": "Farseer Inc",
      "planet": "6 a",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Explorer rank of Scout or higher",
      "unlock": "Provide 1 unit of Meta-Alloys",
      "reputation": "Craft modules, sell exploration data at Farseer Inc"
    },
    {
      "key": "elvira-martuuk",
      "kind": "ship",
      "system": "Khun",
      "base": "Long Sight Base",
      "planet": "5",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Travel at least 300 ly from starting system",
      "unlock": "Provide 3 units of Soontill Relics",
      "reputation": "Craft modules, sell exploration data at Long Sight Base"
    },
    {
      "key": "liz-ryder",
      "kind": "ship",
      "system": "Eurybia",
      "base": "Demolition Unlimited",
      "planet": "Makalu",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Cordial or higher reputation with Eurybia Blue Mafia; complete mission from Chris & Silva's Paradise Hideout",
      "unlock": "Provide 200 units of Landmines",
      "reputation": "Craft modules, sell commodities to Demolition Unlimited"
    },
    {
      "key": "the-dweller",
      "kind": "ship",
      "system": "Wyrd",
      "base": "Black Hide",
      "planet": "A 2",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Deal in stolen or illicit goods at 5 Black Markets",
      "unlock": "Pay 500,000 CR",
      "reputation": "Craft modules, sell commodities to Black Hide"
    },
    {
      "key": "lei-cheung",
      "kind": "ship",
      "system": "Laksak",
      "base": "Trader's Rest",
      "planet": "A 1",
      "region": "Core Systems",
      "discovery": "Learned from The Dweller (after Grade 3 access)",
      "invite": "Trade with at least 50 markets",
      "unlock": "Provide 200 units of Gold",
      "reputation": "Craft modules"
    },
    {
      "key": "selene-jean",
      "kind": "ship",
      "system": "Kuk",
      "base": "Prospector's Rest",
      "planet": "B 3",
      "region": "Core Systems",
      "discovery": "Learned from Tod \"The Blaster\" McQuinn (after Grade 3 access)",
      "invite": "Mine at least 500 tons of ore",
      "unlock": "Provide 10 units of Painite",
      "reputation": "Craft modules, sell commodities or exploration data to Prospector's Rest"
    },
    {
      "key": "hera-tani",
      "kind": "ship",
      "system": "Kuwemaki",
      "base": "The Jet's Hole",
      "planet": "A 3 a",
      "region": "Core Systems",
      "discovery": "Learned from Liz Ryder (after Grade 3 access)",
      "invite": "Imperial Navy rank of Outsider or higher",
      "unlock": "Provide 50 units of Kamitra Cigars",
      "reputation": "Craft modules, sell commodities to The Jet's Hole"
    },
    {
      "key": "broo-tarquin",
      "kind": "ship",
      "system": "Muang",
      "base": "Broo's Legacy",
      "planet": "5 a",
      "region": "Core Systems",
      "discovery": "Learned from Hera Tani (after Grade 3 access)",
      "invite": "Combat rank of Competent or higher",
      "unlock": "Provide 50 units of Fujin Tea",
      "reputation": "Craft modules, hand in bounty vouchers at Broo's Legacy"
    },
    {
      "key": "marco-qwent",
      "kind": "ship",
      "system": "Sirius",
      "base": "Qwent Research Base",
      "planet": "Lucifer",
      "region": "Core Systems",
      "permitRequired": true,
      "discovery": "Learned from Elvira Martuuk (after Grade 3 access)",
      "invite": "Ally reputation with Sirius Corporation",
      "unlock": "Provide 25 units of Modular Terminals",
      "reputation": "Craft modules, sell commodities to Qwent Research Base"
    },
    {
      "key": "zacariah-nemo",
      "kind": "ship",
      "system": "Yoru",
      "base": "Nemo Cyber Party Base",
      "planet": "4",
      "region": "Core Systems",
      "discovery": "Learned from Elvira Martuuk (after Grade 3 access)",
      "invite": "Friendly or higher reputation with Party of Yoru",
      "unlock": "Provide 25 units of Xihe Biomorphic Companions",
      "reputation": "Craft modules, sell commodities to Nemo Cyber Party Base"
    },
    {
      "key": "didi-vatermann",
      "kind": "ship",
      "system": "Leesti",
      "base": "Vatermann LLC",
      "planet": "1 a",
      "region": "Core Systems",
      "discovery": "Learned from Selene Jean (after Grade 3 access)",
      "invite": "Trade rank of Merchant or higher",
      "unlock": "Provide 50 units of Lavian Brandy",
      "reputation": "Craft modules"
    },
    {
      "key": "colonel-bris-dekker",
      "kind": "ship",
      "system": "Sol",
      "base": "Dekker's Yard",
      "planet": "Iapetus",
      "region": "Core Systems",
      "permitRequired": true,
      "discovery": "Learned from Juri Ishmaak (after Grade 3 access)",
      "invite": "Friendly or higher reputation with the Federation",
      "unlock": "Provide 1,000,000 CR worth of combat bonds",
      "reputation": "Craft modules"
    },
    {
      "key": "juri-ishmaak",
      "kind": "ship",
      "system": "Giryak",
      "base": "Pater's Memorial",
      "planet": "2 a",
      "region": "Core Systems",
      "discovery": "Learned from Felicity Farseer (after Grade 3 access)",
      "invite": "Earn at least 50 combat bonds",
      "unlock": "Provide 100,000 CR worth of combat bonds",
      "reputation": "Craft modules, hand in combat bonds to Pater's Memorial"
    },
    {
      "key": "professor-palin",
      "kind": "ship",
      "system": "Arque",
      "base": "Abel Laboratory",
      "planet": "4 e",
      "region": "Core Systems",
      "discovery": "Learned from Marco Qwent (after Grade 3 access)",
      "invite": "Travel at least 5,000 ly from starting system",
      "unlock": "Provide 25 units of Sensor Fragments",
      "reputation": "Craft modules, sell exploration data to Abel Laboratory"
    },
    {
      "key": "chloe-sedesi",
      "kind": "ship",
      "system": "Shenve",
      "base": "Cinder Dock",
      "planet": "A 6",
      "region": "Witch Head Nebula",
      "discovery": "Learned from Marco Qwent (after Grade 3 access)",
      "invite": "Travel at least 5,000 ly from starting system",
      "unlock": "Provide 25 units of Sensor Fragments",
      "reputation": "Craft modules, sell exploration data to Cinder Dock"
    },
    {
      "key": "bill-turner",
      "kind": "ship",
      "system": "Alioth",
      "base": "Turner Metallics Inc",
      "planet": "4 a",
      "region": "Core Systems",
      "permitRequired": true,
      "discovery": "Learned from Selene Jean (after Grade 3 access)",
      "invite": "Friendly or higher reputation with the Alliance",
      "unlock": "Provide 50 units of Bromellite",
      "reputation": "Craft modules"
    },
    {
      "key": "lori-jameson",
      "kind": "ship",
      "system": "Shinrarta Dezhra",
      "base": "Jameson Base",
      "planet": "A 1",
      "region": "Core Systems",
      "permitRequired": true,
      "discovery": "Learned from Marco Qwent (after Grade 3 access)",
      "invite": "Combat rank of Dangerous or higher",
      "unlock": "Provide 25 units of Kongga Ale",
      "reputation": "Craft modules, sell exploration data to Jameson Base"
    },
    {
      "key": "ram-tah",
      "kind": "ship",
      "system": "Meene",
      "base": "Phoenix Base",
      "planet": "AB 5 d",
      "region": "Core Systems",
      "discovery": "Learned from Lei Cheung (after Grade 3 access)",
      "invite": "Explorer rank of Surveyor or higher",
      "unlock": "Provide 50 units of Classified Scan Databanks",
      "reputation": "Craft modules, sell exploration data to Phoenix Base"
    },
    {
      "key": "tiana-fortune",
      "kind": "ship",
      "system": "Achenar",
      "base": "Fortune's Loss",
      "planet": "4 a",
      "region": "Core Systems",
      "permitRequired": true,
      "discovery": "Learned from Hera Tani (after Grade 3 access)",
      "invite": "Friendly or higher reputation with the Empire",
      "unlock": "Provide 50 units of Decoded Emission Data",
      "reputation": "Craft modules, sell commodities to Fortune's Loss"
    },
    {
      "key": "the-sarge",
      "kind": "ship",
      "system": "Beta-3 Tucani",
      "base": "The Beach",
      "planet": "2 b a",
      "region": "Core Systems",
      "discovery": "Learned from Juri Ishmaak (after Grade 3 access)",
      "invite": "Federal Navy rank of Midshipman or higher",
      "unlock": "Provide 50 units of Aberrant Shield Pattern Analysis",
      "reputation": "Craft modules, sell exploration data to The Beach"
    },
    {
      "key": "etienne-dorn",
      "kind": "ship",
      "system": "Los",
      "base": "Kraken's Retreat",
      "planet": "A 2 b",
      "region": "Colonia Region",
      "discovery": "Learned from Liz Ryder (after Grade 3 access)",
      "invite": "Trade rank of Dealer or higher",
      "unlock": "Provide 25 units of Occupied Escape Pods",
      "reputation": "Craft modules"
    },
    {
      "key": "marsha-hicks",
      "kind": "ship",
      "system": "Tir",
      "base": "The Watchtower",
      "planet": "A 2",
      "region": "Colonia Region",
      "discovery": "Learned from The Dweller (after Grade 3 access)",
      "invite": "Explorer rank of Surveyor or higher",
      "unlock": "Provide 10 units of Osmium",
      "reputation": "Craft modules"
    },
    {
      "key": "mel-brandon",
      "kind": "ship",
      "system": "Luchtaine",
      "base": "The Brig",
      "planet": "A 1 c",
      "region": "Colonia Region",
      "discovery": "Learned from Elvira Martuuk",
      "invite": "Friendly or higher reputation with Colonia Council",
      "unlock": "Provide 100,000 credits of bounty vouchers",
      "reputation": "Craft modules"
    },
    {
      "key": "petra-olmanova",
      "kind": "ship",
      "system": "Asura",
      "base": "Sanctuary",
      "planet": "1 a",
      "region": "Colonia Region",
      "discovery": "Learned from Tod \"The Blaster\" McQuinn (after Grade 3 access)",
      "invite": "Combat rank of Expert or higher",
      "unlock": "Provide 200 units of Progenitor Cells",
      "reputation": "Craft modules"
    },
    {
      "key": "domino-green",
      "kind": "on-foot",
      "system": "Orishis",
      "base": "The Jackrabbit",
      "planet": "4",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Travel 100 ly in Apex Interstellar Transport shuttles",
      "referral": "Provide 5 units of Push",
      "refersTo": "kit-fowler",
      "offers": [
        "Enhanced Tracking",
        "Extra Backpack Capacity",
        "Reduced Tool Battery Consumption",
        "Greater Range",
        "Stability"
      ]
    },
    {
      "key": "hero-ferrari",
      "kind": "on-foot",
      "system": "Siris",
      "base": "Nevermore Terrace",
      "planet": "5 c",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Complete 10 Conflict Zones (on foot)",
      "referral": "Provide 5 Settlement Defence Plans",
      "refersTo": "wellington-beck",
      "offers": [
        "Improved Jump Assist",
        "Increased Air Reserves",
        "Increased Sprint Duration",
        "Faster Handling",
        "Noise Suppressor"
      ]
    },
    {
      "key": "jude-navarro",
      "kind": "on-foot",
      "system": "Aurai",
      "base": "Marshall's Drift",
      "planet": "1 a",
      "region": "Core Systems",
      "discovery": "Common knowledge",
      "invite": "Complete 10 Restore or Reactivation missions",
      "referral": "Provide 5 Genetic Repair Meds",
      "refersTo": "terra-velasquez",
      "offers": [
        "Added Melee Damage",
        "Damage Resistance",
        "Extra Ammo Capacity",
        "Magazine Size",
        "Reload Speed"
      ]
    },
    {
      "key": "kit-fowler",
      "kind": "on-foot",
      "system": "Capoya",
      "base": "The Last Call",
      "planet": "2",
      "region": "Core Systems",
      "discovery": "Learned from Domino Green",
      "invite": "Sell 5 Opinion Polls to Bartenders",
      "referral": "Provide 5 Surveillance Equipment",
      "refersTo": "yarden-bond",
      "offers": [
        "Added Melee Damage",
        "Extra Ammo Capacity",
        "Faster Shield Regen",
        "Magazine Size",
        "Stowed Reloading"
      ]
    },
    {
      "key": "oden-geiger",
      "kind": "on-foot",
      "system": "Candiaei",
      "base": "Ankh's Promise",
      "planet": "9 c",
      "region": "Core Systems",
      "discovery": "Learned from Terra Velasquez",
      "invite": "Sell 20 total units of Biological Sample, Employee Genetic Data, and/or Genetic Research to Bartenders",
      "referral": null,
      "refersTo": null,
      "offers": [
        "Enhanced Tracking",
        "Improved Battery Capacity",
        "Night Vision",
        "Scope",
        "Stability"
      ]
    },
    {
      "key": "terra-velasquez",
      "kind": "on-foot",
      "system": "Shou Xing",
      "base": "Rascal's Choice",
      "planet": "1",
      "region": "Core Systems",
      "discovery": "Learned from Jude Navarro",
      "invite": "Complete 6 Covert Heist or Covert Theft missions",
      "referral": "Provide 15 Financial Projections",
      "refersTo": "oden-geiger",
      "offers": [
        "Combat Movement Speed",
        "Increased Air Reserves",
        "Increased Sprint Duration",
        "Improved Hip Fire Accuracy",
        "Noise Suppressor"
      ]
    },
    {
      "key": "uma-laszlo",
      "kind": "on-foot",
      "system": "Xuane",
      "base": "Laszlo's Resolve",
      "planet": "A 3",
      "region": "Core Systems",
      "discovery": "Learned from Wellington Beck",
      "invite": "Reach Unfriendly reputation or lower with Sirius Corporation",
      "referral": null,
      "refersTo": null,
      "offers": [
        "Damage Resistance",
        "Faster Shield Regen",
        "Headshot Damage",
        "Reload Speed",
        "Stowed Reloading"
      ]
    },
    {
      "key": "wellington-beck",
      "kind": "on-foot",
      "system": "Jolapa",
      "base": "Beck Facility",
      "planet": "6 a",
      "region": "Core Systems",
      "discovery": "Learned from Hero Ferrari",
      "invite": "Sell 15 total units of Classic Entertainment, Multimedia Entertainment, and/or Cat Media to Bartenders",
      "referral": "Provide 5 InSight Entertainment Suites",
      "refersTo": "uma-laszlo",
      "offers": [
        "Extra Backpack Capacity",
        "Improved Battery Capacity",
        "Reduced Tool Battery Consumption",
        "Greater Range",
        "Scope"
      ]
    },
    {
      "key": "yarden-bond",
      "kind": "on-foot",
      "system": "Bayan",
      "base": "Salamander Bank",
      "planet": "7 b",
      "region": "Core Systems",
      "discovery": "Learned from Kit Fowler",
      "invite": "Sell 5 Smear Campaign Plans to Bartenders",
      "referral": null,
      "refersTo": null,
      "offers": [
        "Combat Movement Speed",
        "Improved Jump Assist",
        "Quieter Footsteps",
        "Audio Masking",
        "Faster Handling",
        "Improved Hip Fire Accuracy"
      ]
    },
    {
      "key": "baltanos",
      "kind": "on-foot",
      "system": "Deriso",
      "base": "The Divine Apparatus",
      "planet": "3 a",
      "region": "Colonia Region",
      "discovery": "Common knowledge",
      "invite": "Friendly reputation with Colonia Council",
      "referral": "Provide 10 Faction Associates",
      "refersTo": "yi-shen",
      "offers": [
        "Combat Movement Speed",
        "Improved Jump Assist",
        "Increased Air Reserves",
        "Increased Sprint Duration",
        "Faster Handling",
        "Improved Hip Fire Accuracy",
        "Noise Suppressor"
      ]
    },
    {
      "key": "eleanor-bresa",
      "kind": "on-foot",
      "system": "Desy",
      "base": "Bresa Modifications",
      "planet": "7 a",
      "region": "Colonia Region",
      "discovery": "Common knowledge",
      "invite": "Visit 5 Settlements in Colonia",
      "referral": "Provide 10 Digital Designs",
      "refersTo": "yi-shen",
      "offers": [
        "Added Melee Damage",
        "Damage Resistance",
        "Extra Ammo Capacity",
        "Faster Shield Regen",
        "Magazine Size",
        "Reload Speed",
        "Stowed Reloading"
      ]
    },
    {
      "key": "rosa-dayette",
      "kind": "on-foot",
      "system": "Kojeara",
      "base": "Rosa's Shop",
      "planet": "4 b",
      "region": "Colonia Region",
      "discovery": "Common knowledge",
      "invite": "Sell 10 total Culinary Recipes and/or Cocktail Recipes to Bartenders in Colonia",
      "referral": "Provide 10 Manufacturing Instructions",
      "refersTo": "yi-shen",
      "offers": [
        "Enhanced Tracking",
        "Extra Backpack Capacity",
        "Improved Battery Capacity",
        "Reduced Tool Battery Consumption",
        "Greater Range",
        "Scope",
        "Stability"
      ]
    },
    {
      "key": "yi-shen",
      "kind": "on-foot",
      "system": "Einheriar",
      "base": "Eidolon Hold",
      "planet": "1 a",
      "region": "Colonia Region",
      "discovery": "Learned from Baltanos, Eleanor Bresa, and Rosa Dayette",
      "invite": "Complete all referral tasks for Baltanos, Eleanor Bresa, and Rosa Dayette",
      "referral": null,
      "refersTo": null,
      "offers": [
        "Night Vision",
        "Quieter Footsteps",
        "Audio Masking",
        "Headshot Damage"
      ]
    }
  ]
}
